// Stores the home-block advertising result in Redux so it ships via
// window.__INITIAL_STATE__ to the browser.
import { FETCH_ADVERTISING_HOMEBLOCK_SUCCESS } from "./advertisingActionTypes";
import { FetchAdvertisingHomeBlockResult } from "./advertisingActionCreators";

export type AdvertisingState = FetchAdvertisingHomeBlockResult["data"] | null;

type AdvertisingSuccessAction = {
	type: typeof FETCH_ADVERTISING_HOMEBLOCK_SUCCESS;
	res: FetchAdvertisingHomeBlockResult;
};

const isAdvertisingSuccess = (action: { type: string }): action is AdvertisingSuccessAction =>
	action.type === FETCH_ADVERTISING_HOMEBLOCK_SUCCESS;

export default function advertisingReducer(
	state: AdvertisingState = null,
	action: { type: string }
): AdvertisingState {
	if (isAdvertisingSuccess(action)) {
		return action.res.data;
	}
	return state;
}
